import {
  SET_ACTIVE_JOB_ROLES,
  SET_COMPARE_CTC_ANALYSIS,
  SET_COMPARE_CTC_CATEGORY,
  SET_COMPARE_JOB_PROFILE_STATUS,
  SET_COMPARE_STUDENT_PLACEMENT,
  SET_CTC_ANALYSIS,
  SET_CTC_CATEGORY,
  SET_DASHBOARD_DETAILS,
  SET_FILTERED_DASHBOARD_DETAILS,
  SET_JOB_PROFILE_STATUS,
  SET_STUDENT_PLACEMENT,
} from './action'
const initialState = {
  filteredDashboardDetails: {},
  dashboardDetails: {},
  jobProfileStatusDetails: [],
  ctcCategory: [],
  ctcAnalysis: [],
  activeJobRoles: [],
  studentPlacement: {},
  compareJobProfileStatusDetails: [],
  compareCtcCategory: [],
  compareCtcAnalysis: [],
  compareStudentPlacement: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTERED_DASHBOARD_DETAILS:
      return {
        ...state,
        filteredDashboardDetails: action.data,
      }
    case SET_DASHBOARD_DETAILS:
      return {
        ...state,
        dashboardDetails: action.data,
      }
    case SET_JOB_PROFILE_STATUS:
      return {
        ...state,
        jobProfileStatusDetails: action.data,
      }
    case SET_COMPARE_JOB_PROFILE_STATUS:
      return {
        ...state,
        compareJobProfileStatusDetails: action.data,
      }
    case SET_CTC_CATEGORY:
      return {
        ...state,
        ctcCategory: action.data,
      }
    case SET_CTC_ANALYSIS:
      return {
        ...state,
        ctcAnalysis: action.data,
      }
    case SET_COMPARE_CTC_ANALYSIS:
      return {
        ...state,
        compareCtcAnalysis: action.data,
      }
    case SET_COMPARE_CTC_CATEGORY:
      return {
        ...state,
        compareCtcCategory: action.data,
      }
    case SET_ACTIVE_JOB_ROLES:
      return {
        ...state,
        activeJobRoles: action.data,
      }
    case SET_STUDENT_PLACEMENT:
      return {
        ...state,
        studentPlacement: action.data,
      }
    case SET_COMPARE_STUDENT_PLACEMENT:
      return {
        ...state,
        compareStudentPlacement: action.data,
      }
    default:
      return state
  }
}
